module.exports = __webpack_public_path__ + "static/dragon_cultist_mtg_clb-5e53e7a3a95ca45eac5fe96f23b7b423.jpg";